import React, { useState, useEffect } from 'react';
import { getChildGoalProgress } from '../../services/auth';

interface GoalProgressCardProps {
  studentId: string;
}

export const GoalProgressCard: React.FC<GoalProgressCardProps> = ({ studentId }) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getChildGoalProgress(studentId)
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [studentId]);

  if (loading) return <div className="goal-progress-card loading">Loading goals...</div>;
  if (!data || !data.goals || !data.goals.questions_per_day && !data.goals.minutes_per_day && !data.goals.accuracy_target) {
    return (
      <div className="goal-progress-card empty">
        <p>No daily goals set yet.</p>
      </div>
    );
  }

  const { goals, progress, met } = data;

  const renderGoalBar = (
    label: string,
    current: number,
    target: number,
    isMet: boolean,
    unit: string
  ) => {
    const pct = Math.min((current / target) * 100, 100);
    return (
      <div className="goal-row" key={label}>
        <div className="goal-label">
          <span>{label}</span>
          <span className={`goal-status ${isMet ? 'met' : ''}`}>
            {current}{unit} / {target}{unit}
            {isMet && ' \u2713'}
          </span>
        </div>
        <div className="goal-bar">
          <div
            className={`goal-bar-fill ${isMet ? 'complete' : ''}`}
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="goal-progress-card">
      <h4>Today's Goal Progress</h4>
      <div className="goal-rows">
        {goals.questions_per_day && renderGoalBar(
          'Questions', progress.questions_today, goals.questions_per_day, met.questions_met, ''
        )}
        {goals.minutes_per_day && renderGoalBar(
          'Minutes', progress.minutes_today, goals.minutes_per_day, met.minutes_met, 'min'
        )}
        {goals.accuracy_target && renderGoalBar(
          'Accuracy', progress.accuracy_today, goals.accuracy_target, met.accuracy_met, '%'
        )}
      </div>
    </div>
  );
};
